var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"preloader",attrs:{"id":"preloader","layout":"row center-center"}},[_c('img',{ref:"dot",attrs:{"id":"dot","src":require("@/assets/dot.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }